var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useEntity } from '../hooks/use-entity';
import { ContentNode } from './content-node';
var cls = classNames('content-entity-outro');
export var ContentEntityOutroDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    line-height: 1.45em;\n    font-weight: 300;\n    font-size: ", "em;\n  "], ["\n    color: ", ";\n    line-height: 1.45em;\n    font-weight: 300;\n    font-size: ", "em;\n  "])), theme.COLOR('text'), 16 / 13)
});
// -------- Components -------->
var My = {
  Container: styled(ContentNode)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
/**
 * Displays the `outro` field of a `ContentEntity` (e.g. `Page` or `Post`) in a `ContentNode` component
 * (which in turn renders the markdown within the `outro` field.). This uses a slightly larger font than
 * standard content, but this can be overridden by the consuming component.
 */
export var ContentEntityOutro = function (props) {
  var className = props.className,
    children = props.children;
  var entity = useEntity(props.entity);
  var outro = entity.outro;
  return React.createElement(My.Container, {
    entity: outro,
    className: cls.name(className)
  });
};
ContentEntityOutro.defaultProps = ContentEntityOutroDefaultProps;
var templateObject_1, templateObject_2;